module.exports = __webpack_public_path__ + "static/media/werare.16ccc657.jpg";